export enum ATTACHMENT_TYPE {
  PUBLIC = 'public',
  PRIVATE = 'private'
}
